import React from 'react';
import CaseActionsSection from '../../../sections/AdminDashboard/Configuration/CaseActions';

const CaseActions = () => <CaseActionsSection />;

export default CaseActions;
